import {useParams} from "react-router";
import {useEffect, useState} from "react";
import FormLayout from "../../../componets/layout/FormLayout";
import Input from "../../../componets/inputs/Input";
import InputSelect from "../../../componets/inputs/inputSelect";
import Alert from "../../../helpers/Alert";
import userApi from "../../../services/userApi";

export default function FormUsers() {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const defaltValues = {
        id: '',
        nome: '',
        email: '',
        password: '',
        telefone: '',
        status: 1,
        password_repeat: '',
    }
    const [state, setState]: any = useState(defaltValues);
    useEffect(() => {
        if (params.id){
            getData()
        }else{
            setLoading(false)
        }
    }, [])

    const getData = async () => {
        setLoading(true);
        // @ts-ignore
        const {data, isError} = await userApi.one(params.id.toString());
        setState(
            {
                id: data.id,
                nome: data.nome,
                email: data.email,
                password: data.password,
                telefone: data.telefone,
                status: data.status,
            }
        )
        setLoading(false);
    }

    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };

    const statusOptions = [
        { value: 1, label: 'Ativo' },
        { value: 0, label: 'Inativo' },
    ];

    const valPassword = () => {

        if (state.password !== state.password_repeat){
            const newState = {...state}
            newState.password_repeat = '';
            setState(newState);
            Alert.error('Senhas são diferentes!')
        }
    }

    return(
        <FormLayout
            title={'Cadastro de usuário'}
            urlReturn={'/usuarios'}
            state={state}
            setState={setState}
            apiData={userApi}
            defaltValues={defaltValues}
        >
            {
                loading ?
                    <span className="flex items-center justify-center h-7">
                    <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </span>
                :
                <div className={'flex md:flex-row w-full md:p-5 xs:p-1'}>
                    <div className={'w-full grid'}>
                        <div className="grid grid-cols-12 gap-5">
                            <Input
                                label={'Nome'}
                                value={state.nome}
                                required
                                className={'md:col-span-4 xs:col-span-12'}
                                setValue={(v) => handleChange(v, 'nome')}
                            />
                            <Input
                                label={'E-mail'}
                                value={state.email}
                                required
                                className={'md:col-span-4 xs:col-span-12'}
                                inputType={'email'}
                                setValue={(v) => handleChange(v, 'email')}
                            />
                            <Input
                                label={'Telefone'}
                                value={state.telefone}
                                className={'md:col-span-2 xs:col-span-12'}
                                mask={'cellphone'}
                                setValue={(v) => handleChange(v, 'telefone')}
                            />
                            <InputSelect
                                key={(Math.random() + 1).toString(36).substring(7)}
                                /*selected={statusOptions.filter((status: any) => status.value === state.status)}*/
                                selected={state.status}
                                required={true}
                                label={'Status'}
                                className={'md:col-span-2 xs:col-span-12'}
                                options={statusOptions}
                                onChangeSelect={(e: any) => handleChange(e.value, 'status')}
                                placeholder={'Status'}
                            />
                            {
                                state.id ? ''
                                    :
                                 <>
                                     <Input
                                         label={'Senha'}
                                         inputType={'password'}
                                         value={state.password}
                                         required
                                         className={'md:col-span-3 xs:col-span-12'}
                                         setValue={(v) => handleChange(v, 'password')}
                                     />
                                     <Input
                                         inputType={'password'}
                                         onBlur={valPassword}
                                         label={'Repita a Senha'}
                                         value={state.password_repeat}
                                         required
                                         className={'md:col-span-3 xs:col-span-12'}
                                         setValue={(v) => handleChange(v, 'password_repeat')}
                                     />
                                 </>
                            }

                        </div>
                    </div>
                </div>
            }
        </FormLayout>
    )
}